export default {
  namespaced: true,
  actions: {
    lockVideoSessionScreen({commit}) {
      commit('setVideoScreenLocked', true);
      document.body.classList.add("video-screen-locked");
    },
    unlockVideoSessionScreen({commit}) {
      commit('setVideoScreenLocked', false);
      document.body.classList.remove("video-screen-locked");
    },
  },
  mutations: {
    setAppError(state, hasError) {
      state.hasAppError = hasError
    },
    setVideoScreenLocked(state, locked) {
      state.videoScreenLocked = locked
    },
    setCallsInProgress(state, isCallInProgress) {
      state.isCallInProgress = isCallInProgress
    }
  },
  state: {
    hasAppError: false,
    videoScreenLocked: false,
    isCallInProgress: false
  }
}
